module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-12.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-12.png
// module id = 1387
// module chunks = 0